import { useCallback, useState } from 'react'

import { useOnChange } from './useOnChange'

export const useAsyncToggle = (initialState = false, callback?: (value: boolean) => Promise<unknown>) => {
  const [state, setState] = useState(initialState)
  const [isLoading, setIsLoading] = useState(false)

  useOnChange(initialState, () => setState(initialState))

  const toggle = useCallback(
    async (newState: boolean = !state) => {
      setIsLoading(true)
      const previousState = state
      setState(newState)
      if (callback) {
        try {
          await callback(newState)
        } catch (_) {
          setState(previousState)
        }
      }
      setIsLoading(false)
    },
    [callback, state],
  )

  return [state, toggle, isLoading] as const
}
